import { loadUser } from '../../utils/storage'

export default {
  user: loadUser(),
  permissions: null
}
